import request from './request'

// 查询媒体库各项的子类别
export const ossFileTypeList = (params) => {
    return request({
        url: '/system/ossFileType/list',
        method: 'get',
        params
    })
}

// 新增子类别
export const addOssFileType = (data) => {
    return request({
        url: '/system/ossFileType',
        method: 'post',
        data
    })
}

// 修改子类别
export const putOssFileType = (data) => {
    return request({
        url: '/system/ossFileType',
        method: 'put',
        data
    })
}

// 删除子类别
export const delOssFileType = (recIds) => {
    return request({
        url: `/system/ossFileType/${recIds}`,
        method: 'delete',
    })
}

// 删除上传的资源文件
export const delOssFile = (recIds) => {
    console.log(recIds,'recIds')
    return request({
        url: `/resource/oss/${recIds}`,
        method: 'delete',
    })
}
// 删除资源
export const ossUserList = (params) => {
    return request({
        url: '/resource/oss/userList',
        method: 'get',
        params
    })
}
// 获取快捷消息类型
export const quickMessageTypeList = (params) => {
    return request({
        url: '/mf/quickMessageType/list',
        method: 'get',
        params
    })
}
// 获取快捷消息
export const quickMessageType = (recIds) => {
    return request({
        url: `/mf/quickMessageType/${recIds}`,
        method: 'get',
    })
}
// 创建快捷消息类型
export const addQuickMessageType = (data) => {
    console.log(data,'data')
    return request({
        url: '/mf/quickMessageType',
        method: 'post',
        headers:{
            isEncrypt: false
        },
        data
    })
}
// 修改快捷消息类型
export const editQuickMessageType = (data) => {
    return request({
        url: '/mf/quickMessageType',
        method: 'PUT',
        headers:{
            isEncrypt: false
        },
        data
    })
}
// 删除快捷消息类型
// /mf/quickMessageType/{recIds}
export const delQuickMessageType = (recIds) => {
    console.log(recIds,'recIds')
    return request({
        url: `/mf/quickMessageType/${recIds}`,
        method: 'delete',
    })
}
// 获取类型下的快捷消息列表
export const quickMessageList = (params) => {
    return request({
        url: '/mf/quickMessage/list',
        method: 'get',
        params
    })
}
// 添加快捷消息内容
export const addQuickMessage = (data) => {
    console.log(data,'data')
    return request({
        url: '/mf/quickMessage',
        method: 'post',
        headers:{
            isEncrypt: false
        },
        data
    })
}

// 修改快捷消息内容
export const editQuickMessage = (data) => {
    return request({
        url: '/mf/quickMessage',
        method: 'PUT',
        headers:{
            isEncrypt: false
        },
        data
    })
}

// 删除消息
export const delQuickMessage = (recIds) => {
    console.log(recIds,'recIds')
    return request({
        url: `/mf/quickMessage/${recIds}`,
        method: 'delete',
    })
}